import { useState } from "react";
import { parse } from "query-string";
import _ from "lodash";

import { SignUpGetStarted } from "./sign-up-get-started/SignUpGetStarted";
import { SignUpForm, SIGNUP_FORM_STORAGE_KEY } from "./sign-up-form/SignUpForm";
import { OB_SEARCH_QUERY_KEY } from "./useSignUp";
import {
  getReferralEmailVariation,
  getReferralSource,
} from "./optimised-signup/helper";

import { setItem } from "src/common/local-storage/local-storage";
import { useRouterQuery } from "src/common/routing";
import { CountryCodeSupported } from "src/common/country";

export enum SignUpAccountType {
  SELF_SERVED = "self_served",
  SALES_SERVED = "sales_served",
}
interface SignUpProps {
  country: CountryCodeSupported;
  accountType: SignUpAccountType;
  isPaymentProvider?: boolean;
  hasFsbMemberDiscount?: boolean;
}

export const SignUp: React.FC<SignUpProps> = ({
  country,
  accountType,
  isPaymentProvider,
  hasFsbMemberDiscount,
}) => {
  const [emailAddress, setEmailAddress] = useState("");

  const formDetails = sessionStorage.getItem(SIGNUP_FORM_STORAGE_KEY);
  const [getStartedVisible, setGetStartedVisible] = useState(!formDetails);

  const { item: referralGeo } = useRouterQuery("referral_geo");
  const { item: referralCode } = useRouterQuery("referral_code");
  const { item: referralCodeName } = useRouterQuery("referral_code_name");
  const { item: defaultReferralGeo } = useRouterQuery("geo");
  const { item: defaultReferralCodeName } = useRouterQuery("name");
  const { item: defaultReferralCode } = useRouterQuery("code");
  const { item: defaultReferralSource } = useRouterQuery("s");
  const { item: defaultReferralEmailVariation } = useRouterQuery("v");

  const referralsSource = getReferralSource(
    defaultReferralSource,
    defaultReferralEmailVariation
  );

  const referralEmailVariation = getReferralEmailVariation(
    defaultReferralEmailVariation
  );
  const qs = parse(window.location.search);
  if (Object.keys(qs).includes("ob")) {
    setItem(OB_SEARCH_QUERY_KEY, "true");
  }

  const submitGetStarted = (email: string) => {
    setEmailAddress(email);
    setGetStartedVisible(false);
  };

  return getStartedVisible ? (
    <SignUpGetStarted
      country={country}
      accountType={accountType}
      referralGeo={
        defaultReferralGeo ? _.toUpper(defaultReferralGeo) : referralGeo
      }
      referralCode={defaultReferralCode || referralCode}
      referralCodeName={
        defaultReferralCodeName
          ? _.capitalize(defaultReferralCodeName)
          : referralCodeName
      }
      isPaymentProvider={isPaymentProvider}
      hasFsbMemberDiscount={hasFsbMemberDiscount}
      referralSource={referralsSource}
      referralVariation={referralEmailVariation}
      submit={submitGetStarted}
    />
  ) : (
    <SignUpForm
      emailAddress={emailAddress}
      country={country}
      accountType={accountType}
      referralGeo={
        defaultReferralGeo ? _.toUpper(defaultReferralGeo) : referralGeo
      }
      referralCode={defaultReferralCode || referralCode}
      referralCodeName={
        defaultReferralCodeName
          ? _.capitalize(defaultReferralCodeName)
          : referralCodeName
      }
      isPaymentProvider={isPaymentProvider}
      hasFsbMemberDiscount={hasFsbMemberDiscount}
      referralSource={referralsSource}
      referralVariation={referralEmailVariation}
    />
  );
};
